<script setup>
import { inject } from "vue";

import Modal from "@/Components/Modal/Modal.vue";

const emit = defineEmits(["close"]);

const props = defineProps({
  show: {
    type: Boolean,
    required: false,
    default: false
  },
  hideHeader: {
    type: Boolean,
    required: false,
    default: false
  },
  maxWidth: {
    type: String,
    required: false,
    default: "lg"
  },
  closeable: {
    type: Boolean,
    required: false,
    default: true
  },
  headerClass: {
    type: String,
    required: false
  },
  contentClass: {
    type: String,
    required: false
  },
  footerClass: {
    type: String,
    required: false
  }
});

const twMerge = inject("twMerge");

const close = () => {
  emit("close");
};

const computedHeaderClass = twMerge("pb-4", props.headerClass);
const computedContentClass = twMerge("pb-5 text-700", props.contentClass);
const computedFooterClass = twMerge("flex justify-between gap-x-4 whitespace-nowrap pt-4 tracking-wide", props.footerClass);
</script>

<template>
  <Modal :closeable="closeable" :max-width="maxWidth" :show="show" @close="close">
    <div class="p-1">
      <div v-if="!hideHeader" class="dialog-header" :class="computedHeaderClass">
        <div v-if="$slots.title" class="rounded-t-xl">
          <div v-if="$slots.title" class="text-lg font-semibold text-700 dark:text-zinc-100">
            <slot name="title" />
          </div>
        </div>

        <div v-if="$slots.header">
          <slot name="header" />
        </div>
      </div>

      <div class="dialog-content" :class="computedContentClass">
        <slot name="content" />
      </div>

      <div v-if="$slots.footer" class="dialog-footer" :class="computedFooterClass">
        <slot name="footer" />
      </div>
    </div>
  </Modal>
</template>
